import { render } from "./SimpleSpan.vue?vue&type=template&id=64697609&ts=true"
import script from "./SimpleSpan.vue?vue&type=script&lang=ts"
export * from "./SimpleSpan.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__